export const WARDROBES_GALLERY_LIST_PRESET = [
  {
    displayedName: 'Гардеробные',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    price: 122674,
    productName: '',
    style: 'wardrobes',
    rating: 1010,
  },
  {
    displayedName: 'Гардеробные',
    mediaMainPhoto: ['2.jpg/2.jpg'],
    price: 67335,
    productName: '',
    style: 'wardrobes',
    rating: 1016,
  },
  {
    displayedName: 'Гардеробные',
    mediaMainPhoto: ['3.jpg/3.jpg'],
    price: 181955,
    productName: '',
    style: 'wardrobes',
    rating: 1029,
  },
  {
    displayedName: 'Гардеробные',
    mediaMainPhoto: ['4.jpg/4.jpg'],
    price: 126813,
    productName: '',
    style: 'wardrobes',
    rating: 1030,
  },
  {
    displayedName: 'Гардеробные',
    mediaMainPhoto: ['5.jpg/5.jpg'],
    price: 114542,
    productName: '',
    style: 'wardrobes',
    rating: 1022,
  },
  {
    displayedName: 'Гардеробные',
    mediaMainPhoto: ['6.jpg/6.jpg'],
    price: 62334,
    productName: '',
    style: 'wardrobes',
    rating: 1032,
  },
  {
    displayedName: 'Гардеробные',
    mediaMainPhoto: ['7.jpg/7.jpg'],
    price: 162909,
    productName: '',
    style: 'wardrobes',
    rating: 1004,
  },
  {
    displayedName: 'Гардеробные',
    mediaMainPhoto: ['8.jpg/8.jpg'],
    price: 55211,
    productName: '',
    style: 'wardrobes',
    rating: 1025,
  },
  {
    displayedName: 'Гардеробные',
    mediaMainPhoto: ['9.jpg/9.jpg'],
    price: 118000,
    productName: '',
    style: 'wardrobes',
    rating: 1013,
  },
  {
    displayedName: 'Гардеробные',
    mediaMainPhoto: ['10.jpg/10.jpg'],
    price: 158843,
    productName: '',
    style: 'wardrobes',
    rating: 1002,
  },
  {
    displayedName: 'Гардеробные',
    mediaMainPhoto: ['11.jpg/11.jpg'],
    price: 166490,
    productName: '',
    style: 'wardrobes',
    rating: 1007,
  },
  {
    displayedName: 'Гардеробные',
    mediaMainPhoto: ['12.jpg/12.jpg'],
    price: 108000,
    productName: '',
    style: 'wardrobes',
    rating: 1019,
  },
  {
    displayedName: 'Гардеробные',
    mediaMainPhoto: ['13.jpg/13.jpg'],
    price: 176734,
    productName: '',
    style: 'wardrobes',
    rating: 1024,
  },
];
